import { render, staticRenderFns } from "./CommentsSection.vue?vue&type=template&id=82eacb06&scoped=true"
import script from "./CommentsSection.vue?vue&type=script&lang=js"
export * from "./CommentsSection.vue?vue&type=script&lang=js"
import style0 from "./CommentsSection.vue?vue&type=style&index=0&id=82eacb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eacb06",
  null
  
)

export default component.exports